"use strict";

define('view/table.card',['require','exports','module','uikit/uikit'],function (require, exports, module) {
  var UIKit = require('uikit/uikit');
  var EmptyTableCard = UIKit.Container.extend({
    className: 'ui center aligned segment',
    options: {
      text: null,
      icon: null
    },
    bindings: {
      text: 'text',
      icon: 'icon'
    },
    initialize: function initialize() {
      UIKit.Container.prototype.initialize.apply(this, arguments);
      this.header = new UIKit.Header({
        muted: true,
        iconHeader: true,
        tagName: 'div',
        attributes: {
          style: 'margin: 0;'
        }
      });
      this.bindOption('text', 'text', this.header);
      this.bindOption('icon', 'icon', this.header);
      this.add(this.header);
    }
  });
  var TableCard = UIKit.Container.extend({
    className: 'ui segments',
    options: {
      headerText: '',
      headerSegmentColor: 'blue',
      columns: null,
      collection: null,
      headerAriaLevel: '2'
    },
    bindings: {
      headerText: 'header',
      collection: 'collection'
    },
    initialize: function initialize() {
      UIKit.Container.prototype.initialize.apply(this, arguments);
      this.header = new UIKit.Container({
        className: 'ui compact ' + this.headerSegmentColor + ' segment',
        attributes: {
          style: 'margin-top: 1rem'
        }
      });
      var textView = new UIKit.Text({
        className: 'ui tiny header',
        attributes: {
          role: 'heading',
          'aria-level': this.getOption('headerAriaLevel')
        }
      });
      this.bindOption('headerText', 'text', textView);
      this.header.add(textView);
      this.content = new UIKit.Container({
        className: 'ui fitted segment'
      });
      this.table = new UIKit.Table({
        headless: true,
        sortable: false,
        selectable: true,
        columns: this.columns,
        basic: 'very',
        ariaLabelledby: textView.cid
      });
      this.columns = this.table.columns;
      this.bindOption('collection', 'collection', this.table);
      this.content.add(this.table);
      this.add(this.header);
      this.add(this.content);
    }
  });
  TableCard.Empty = EmptyTableCard;
  module.exports = TableCard;
});

